module.exports = __webpack_public_path__ + "static/left-1d5074a4fb1f452e6ef2c349c0a5029b.jpg";